<template>  
    <div v-if="show" class="loading-overlay">  
      <div class="loading-message">Actualizando...</div>  
    </div>  
  </template>  
  
  <script>  
  export default {  
    data() {  
      return {  
        show: true  
      };  
    },  
    methods: {  
      showOverlay() {  
        this.show = true;  
      },  
      hideOverlay() {  
        this.show = false;  
      }  
    }  
  };  
  </script>  
  
  <style scoped>  
  .loading-overlay {  
    position: fixed;  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    background: rgba(0, 0, 0, 0.5);  
    display: flex;  
    justify-content: center;  
    align-items: center;  
    z-index: 1000;  
  }  
  
  .loading-message {  
    color: white;  
    font-size: 24px;  
    font-weight: bold;  
    text-align: center;  
    padding: 20px;  
    background: rgba(0, 0, 0, 0.7);  
    border-radius: 10px;  
  }  
  </style>  